import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseMediaWatcherService } from '@discoverer/fuse/services/media-watcher';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@discoverer/fuse/components/navigation';
import { Navigation } from '@discoverer/app-core/navigation/navigation.types';
import { NavigationService } from '@discoverer/app-core/navigation/navigation.service';
import { UserData, UserDataService } from '@discoverer/app-core/user-data.service';

@Component({
    selector     : 'futuristic-layout',
    templateUrl  : './futuristic.component.html',
    styles: [`
        futuristic-layout fuse-vertical-navigation .fuse-vertical-navigation-wrapper {
            background-color: var(--fuse-primary-900);
            color: var(--fuse-primary-100);
        }


        futuristic-layout .main-view-container {
            height: calc(100vh - 8px) !important;
        }

        futuristic-layout .report-main-grid {
            height: calc(100vh) !important;
        }

        futuristic-layout #pivot-chart .k-grid {
            height: calc(100vh - 280px) !important;
        }
        futuristic-layout .k-chart {
            height: calc(100vh - 280px) !important;
        }
        .mat-icon-button {
            padding-left: 8px !important;
            margin-top: 4px !important;
        }
    `],
    encapsulation: ViewEncapsulation.None
})
export class FuturisticLayoutComponent implements OnInit, OnDestroy
{
    isScreenSmall: boolean;
    navigation: Navigation;
    user: UserData;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _navigationService: NavigationService,
        private _userService: UserDataService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        // Subscribe to the user service
        this._userService.loggedInUser
            .pipe((takeUntil(this._unsubscribeAll)))
            .subscribe((user: UserData) => {
                this.user = user;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
